import { Box, Spinner } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import Streetview from 'react-google-streetview';
import { useCheckStreetViewStatus } from 'hooks/useCheckStreetViewStatus';

interface StreetViewMapProps {
  lat: number;
  lng: number;
  height?: string;
  exteriorOnly?: boolean;
}

const errorText = {
  color: Colors.TextQuiet,
};

const errorContainer = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: Colors.ArmyGreen200,
};

const parentContainer = {
  width: '100%',
  height: '100%',
  position: 'relative' as const,
};

const StreetViewMap = ({
  lat,
  lng,
  height = '150px',
  exteriorOnly = true,
}: StreetViewMapProps) => {
  const googleMapsKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

  const { data, isLoading, isError } = useCheckStreetViewStatus(lat, lng, exteriorOnly);

  const streetViewPanoramaOptions = {
    position: { lat, lng },
    pov: { heading: 100, pitch: 0 },
    zoom: 1,
    disableDefaultUI: true,
    clickToGo: false,
    linksControl: false,
    panControl: false,
    addressControl: false,
    zoomControl: false,
    imageDateControl: true,
    pano: data?.pano_id || undefined,
  };

  if (isLoading) {
    return (
      <Box sx={{ ...parentContainer, height }}>
        <Spinner size="md" color={Colors.TextQuiet} />
      </Box>
    );
  }

  if (!lat || !lng || (isError && !isLoading) || data?.status !== 'OK') {
    return (
      <Box sx={{ ...parentContainer, height }}>
        <Box sx={errorContainer}>
          <Text.Body sx={errorText}>
            {exteriorOnly
              ? 'Exterior Google Street View unavailable'
              : 'Google Street View unavailable'}
          </Text.Body>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ ...parentContainer, height }}>
      <Streetview
        apiKey={googleMapsKey}
        streetViewPanoramaOptions={streetViewPanoramaOptions}
      />
    </Box>
  );
};

export default StreetViewMap;
